module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/clock-icon-9de9bd00e36742bc2b4fdc48e5736f9c.jpg";